function toggleClassMenuMain() {
	myMenu.classList.add("menu--animatable");	
	if(!myMenu.classList.contains("menu--visible")) {		
		myMenu.classList.add("menu--visible");
	} else {
		myMenu.classList.remove('menu--visible');		
	}	
}

function OnTransitionEnd() {
	myMenu.classList.remove("menu--animatable");
}

var el = document.getElementById('overlayBtn');
if(el){
  el.addEventListener('click', swapper, false);
}

var myMenu = document.querySelector(".b-menu");
var oppMenu = document.querySelector(".b-layout__menu-icon");

if(oppMenu || myMenu){
  oppMenu.addEventListener("click", toggleClassMenuMain, false);
  myMenu.addEventListener("click", toggleClassMenuMain, false);
}



// WEBPACK FOOTER //
// ./src/js/pages/promo/menu.js